import { getApi, getId2IdEndpoint } from '../../../utils/api'

export function getRequestLogEvents({
  outboundUuid,
  request_id: requestId,
  ...params
}) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `request/${requestId}/log-events/`,
    }),
    params,
  })
}
